const Permissions = [
  {
    path: '/ecommerce/security/permission',
    name: 'permissions',
    component: () => import(/* webpackChunkName: "permissions" */ '../views/PermissionView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Permissions',
          path: '/ecommerce/security/permission',
        },
      ],
    },
    children: [],
  },
];

export default Permissions;
